'use strict';
function openShop(evt, shopName) {
    // Declare all variables
    let i, tabcontent, tablinks;
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for(i = 0; i < tabcontent.length; i++)tabcontent[i].style.display = "none";
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for(i = 0; i < tablinks.length; i++)tablinks[i].className = tablinks[i].className.replace(" active", "");
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(shopName).style.display = "block";
    evt.currentTarget.className += " active";
}
let slideIndex = 1;
showSlides(slideIndex);
function plusSlides(n) {
    showSlides(slideIndex += n);
}
function currentSlide(n) {
    showSlides(slideIndex = n);
}
function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("tabcontent");
    let dots = document.getElementsByClassName("tablinks");
    if (n > slides.length) slideIndex = 1;
    if (n < 1) slideIndex = slides.length;
    for(i = 0; i < slides.length; i++)slides[i].style.display = "none";
    for(i = 0; i < dots.length; i++)dots[i].className = dots[i].className.replace(" active", "");
    slides[slideIndex - 1].style.display = "block";
    dots[slideIndex - 1].className += " active";
}
window.addEventListener('hashchange', ()=>{
    if (window.location.hash === '#product') document.body.classList.add('page__body--with-product');
    else document.body.classList.remove('page__body--with-product');
});
window.addEventListener('hashchange', ()=>{
    if (window.location.hash === '#menu') document.body.classList.add('page__body--with-menu');
    else document.body.classList.remove('page__body--with-menu');
});
const send = document.querySelector("#a-button");
send.addEventListener("click", sendClick, false);
function sendClick(event) {
    event.preventDefault();
}

//# sourceMappingURL=Eco_cosmetics.3d20f879.js.map
